export const LOCAL_CACHE_FORCE_CLEAR = 'LOCAL_CACHE_FORCE_CLEAR';

export const localCacheForceClear = (): {
    type: typeof LOCAL_CACHE_FORCE_CLEAR;
} => ({
    type: LOCAL_CACHE_FORCE_CLEAR,
});
